import {EmploymentStatus} from "../../app/interfaces";
import styled from "styled-components";
import {EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED} from "../../utils/constants";
import {colorForStatus} from "../../utils";

interface StatusShortDescriptionProps {
    status: EmploymentStatus
}

export const StatusShortDescription = styled.p<StatusShortDescriptionProps>`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.1px;
  color: ${props => props.status === EMPLOYMENT_STATUS_EOR_QUOTE_PROVIDED ? colorForStatus(props.status).color : colorForStatus(props.status).background };
`
